"use client";

import { useMemo } from "react";
import { usePrenotaStore } from "@PN/inclusao";
import { useCatalogs } from "store";

export function useParcelasValidation() {
  const draft = usePrenotaStore((state) => state.draft);
  const aux = usePrenotaStore((state) => state.aux);
  const { pagamentos, produtos, documento } = draft;
  const { condicoes } = useCatalogs();

  // Calcula valorNF usando fonte única da verdade
  const valorNF = useMemo(() => {
    // ✅ Usa o TOTAL da store (definitivamente SUBTOTAL/BRUTO)
    if (
      aux.totalNota &&
      typeof aux.totalNota === "object" &&
      (aux.totalNota as any).total
    ) {
      const totalStr = String((aux.totalNota as any).total || "0");
      const totalNum = Number(totalStr.replace(",", ".")) || 0;
      return totalNum;
    }

    // Fallback: calcula apenas dos produtos do draft (sem duplicação)
    return produtos.reduce((sum, p) => sum + (p.valorTotal || 0), 0);
  }, [produtos, aux.totalNota]);

  // Verifica se pode buscar parcelas
  const canFetch = useMemo(() => {
    return Boolean(
      valorNF > 0 &&
        pagamentos.condicaoFinanceira &&
        documento.dataEmissao &&
        documento.fornecedor &&
        documento.loja
    );
  }, [
    valorNF,
    pagamentos.condicaoFinanceira,
    documento.dataEmissao,
    documento.fornecedor,
    documento.loja,
  ]);

  const condicaoTipo = useMemo(() => {
    if (!pagamentos.condicaoFinanceira) return undefined;
    return condicoes.getBy("E4_CODIGO", pagamentos.condicaoFinanceira)?.E4_TIPO;
  }, [pagamentos.condicaoFinanceira, condicoes]);

  // Parâmetros para consulta
  const params = useMemo(
    () => ({
      valor: valorNF,
      condpag: pagamentos.condicaoFinanceira,
      dtemissao: documento.dataEmissao,
      codForn: documento.fornecedor,
      lojaForn: documento.loja,
      tipo: condicaoTipo,
    }),
    [
      valorNF,
      pagamentos.condicaoFinanceira,
      documento.dataEmissao,
      documento.fornecedor,
      documento.loja,
      condicaoTipo,
    ]
  );

  return {
    valorNF,
    canFetch,
    params,
    pagamentos,
    documento,
  };
}
